import { render, staticRenderFns } from "./PDFDisplay.vue?vue&type=template&id=c74cac46&scoped=true&"
import script from "./PDFDisplay.vue?vue&type=script&lang=js&"
export * from "./PDFDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74cac46",
  null
  
)

export default component.exports